import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareReportsRoute: InvariantJiraRoute = {
	name: 'software-reports',
	path: '/jira/software/projects/:projectKey/boards/:boardId/reports',
	query: ['dashboardId?'],
};
